<div class="emm-item-duplication-form">
  <mat-accordion [multi]="true">
    @for (attributeGroup of attributeGroups; track attributeGroup) {
      <div>
        <mat-expansion-panel
          [ngClass]="{ 'attribute-group-open': attributeGroup == selectedStatus }"
          (closed)="closePanel(attributeGroup)"
          (opened)="openPanel(attributeGroup)"
          [expanded]="true"
          >
          <mat-expansion-panel-header>
            <mat-panel-title [attr.data-testid]="attributeGroup.name">
              {{ attributeGroup.name }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (renderForm | async) {
            <emm-dynamic-management-form
              [attributes]="attributesByGroup.get(attributeGroup.id) | async"
              [attributeGroupId]="attributeGroup.id"
              [locked]="false"
              [isDuplication]="true"
              [itemTag]="'NEW_ITEM'"
              [form]="form | async"
              [locale]="sharedFacade.localeSelected$ | async"
              [showLocaleIcons]="false"
            ></emm-dynamic-management-form>
          }
        </mat-expansion-panel>
      </div>
    }
  </mat-accordion>
  <div class="fixed-buttons-row">
    <button mat-raised-button
      (click)="cancel()"
      >Cancel
    </button>
    <button mat-raised-button
      [disabled]="!hasChanges() || hasInvalidFormfield()"
      (click)="submit()"
      >Add Item
    </button>
  </div>
</div>
